import { Button } from '@jobber/components/Button';
import { Heading } from '@jobber/components/Heading';
import React, { useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../hooks/use-auth';
import { usePermission } from '../../../hooks/use-permission';
import { hasJobberAccess } from '../../../utils/auth';

const JOBBER_CONNECTION_PERMISSION = { integrations: ['update'] };

function Jobber() {
  const { user } = useAuth();
  const location = useLocation();
  const { allowed: canUpdateIntegration, isLoading: permissionLoading } = usePermission(JOBBER_CONNECTION_PERMISSION);
  const [connecting, setConnecting] = useState(false);
  const connected = hasJobberAccess(user);
  const authRequired = new URLSearchParams(location.search).get('reason') === 'auth-required';

  const connectJobber = () => {
    setConnecting(true);
    window.location.assign(`${process.env.REACT_APP_API_URL}/auth`);
  };

  return (
    <div className="mt-3">
      <Heading level={2}>Jobber connection</Heading>

      <div className="mt-3 col-lg-7 col-xl-6">
        {authRequired && (
          <Alert variant="warning">
            The Jobber connection needs to be renewed before this action can continue.
          </Alert>
        )}

        <Alert variant={connected ? 'success' : 'danger'}>
          {connected ? 'Jobber is connected.' : 'Jobber is not connected.'}
        </Alert>

        {permissionLoading ? (
          <Spinner size="sm" />
        ) : canUpdateIntegration ? (
          <Button
            label={connected ? 'Replace Jobber connection' : 'Connect Jobber'}
            onClick={connectJobber}
            disabled={connecting}
          />
        ) : (
          <Alert variant="info">
            An organization administrator must reconnect Jobber.
          </Alert>
        )}
      </div>
    </div>
  );
}

export default Jobber;
